import { Radio, styled } from "@mui/material";

// Custom radio look shared by the purchase-plan and payment-method selectors.
// The icons are plain spans so the Radio's native input keeps driving
// hover/disabled/focus states via sibling and ancestor selectors.
export const PlanRadio = styled(Radio)({
  "&:hover": {
    backgroundColor: "transparent",
  },
});

export const RadioIcon = styled("span")({
  borderRadius: "50%",
  width: 16,
  height: 16,
  boxShadow:
    "inset 0 0 0 1px color-mix(in srgb, var(--text-strong) 20%, transparent), inset 0 -1px 0 color-mix(in srgb, var(--text-strong) 10%, transparent)",
  backgroundColor: "var(--status-success-bg)",
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  ".Mui-focusVisible &": {
    outline: "2px auto color-mix(in srgb, var(--action-brand-deep) 60%, transparent)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "var(--c-slate-100)",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: "color-mix(in srgb, var(--action-disabled-bg) 50%, transparent)",
  },
});

export const RadioCheckedIcon = styled(RadioIcon)({
  backgroundColor: "var(--action-brand)",
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage:
      "radial-gradient(var(--bg-surface),var(--bg-surface) 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "var(--action-brand)",
  },
});
